import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";

/**
 * 以 input 作为输入，按序使用 transform.
 *
 * `applyTransform(input, f1, f2, f3)` 等价于 `f3(f2(f1(input)))` */
export default function applyTransforms(input) {
  for (var _len = arguments.length, transforms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    transforms[_key - 1] = arguments[_key];
  }

  return _reduceInstanceProperty(transforms).call(transforms, function (v, fn) {
    return fn(v);
  }, input);
}